import gatewayRequest from "./gateway-request";
import commonRequest from "./common-request"

/**
 * Description:
 * Author: sunc
 * Date: 2019-06-26
 * Time: 10:43
 */
const httpUtils = {
  /**
   * http 网关get请求方法
   * @param urlName
   * @param params
   */
  getGatewayUtils: (urlName, params) => {
    return gatewayRequest({
      url: urlName,
      method: 'get',
      params
    })
  },
  /**
   * http 网关post请求方法
   * @param urlName
   * @param params
   */
  postGatewayUtils: (urlName, data) => {
    return gatewayRequest({
      url: urlName,
      method: 'post',
      data
    })
  },
  /**
   * http 网关patch请求方法
   * @param urlName
   * @param params
   */
  patchGatewayUtils: (urlName, data) => {
    return gatewayRequest({
      url: urlName,
      method: 'patch',
      data
    })
  },
  /**
   * http 网关put请求方法
   * @param urlName
   * @param id
   * @param data
   */
  putGatewayUtils: (urlName, data) => {
    return gatewayRequest({
      url: urlName,
      method: 'put',
      data
    })
  },
  /**
   * http 网关delete请求方法
   * @param urlName
   * @param id
   */
  deleteGatewayUtils: (urlName) => {
    return gatewayRequest({
      url: urlName,
      method: 'delete'
    })
  },
  /**
   * http get请求方法
   * @param urlName
   * @param params
   */
  getCommonUtils: (urlName, params) => {
    return commonRequest({
      url: urlName,
      method: 'get',
      params
    })
  },

  postJson: (urlName, params) => {
    return commonRequest({
      url: urlName,
      method: 'post',
      data: JSON.stringify(params),
      headers: {"Content-Type": "application/json"}
    })
  },

  /**
   * http post请求方法
   * @param urlName
   * @param params
   */
  postCommonUtils: (urlName, data) => {
    return commonRequest({
      url: urlName,
      method: 'post',
      data
    })
  },
  /**
   * http patch请求方法
   * @param urlName
   * @param params
   */
  patchCommonUtils: (urlName, data) => {
    return commonRequest({
      url: urlName,
      method: 'patch',
      data
    })
  },
  /**
   * http put请求方法
   * @param urlName
   * @param id
   * @param data
   */
  putCommonUtils: (urlName, data) => {
    return commonRequest({
      url: urlName,
      method: 'put',
      data
    })
  },
  /**
   * http delete请求方法
   * @param urlName
   * @param id
   */
  deleteCommonUtils: (urlName) => {
    return commonRequest({
      url: urlName,
      method: 'delete'
    })
  }
}

export default httpUtils
